import React from 'react';
const FileRenderer = ({src,fileType='',name='File preview',onLoad,onError}) => {
 if(fileType.startsWith('image/'))return <img className="attachment-image" src={src} alt={name} onLoad={onLoad} onError={onError}/>;
 if(fileType.startsWith('video/'))return <video className="attachment-media" src={src} controls preload="metadata" onLoadedMetadata={onLoad} onError={onError}/>;
 if(fileType.startsWith('audio/'))return <audio className="attachment-media" src={src} controls preload="metadata" onLoadedMetadata={onLoad} onError={onError}/>;
 return <iframe className="attachment-frame" title={name} src={src} onLoad={onLoad} onError={onError}/>;
};
export default FileRenderer;
